import React, { Fragment, useEffect, useState } from 'react';
import { formatCurrency } from '../../helpers/currencies';
const GiftSetButtons = ({ currentBundle, bundleComponents, currentFocusedBaseProduct, customClass, selectPartToEdit }) => {
    const [productSurcharge, setProductSurcharge] = useState([]);
    useEffect(() => {
        const surcharge = [];
        currentBundle.forEach((bundleProd) => {
            let prodSurcharge = 0;
            Object.values(bundleProd).map((bundleComp) => bundleComp.map((part) => {
                if (Number(part.selectedVariant.surcharge_price) > 0) {
                    return (prodSurcharge += Number(part.selectedVariant.surcharge_price));
                }
            }));
            surcharge.push(prodSurcharge);
        });
        setProductSurcharge(surcharge);
    }, [currentBundle]);
    return (React.createElement("div", { className: `gift-set-buttons ${customClass}` }, currentBundle.map((bundleProd, baseProdIndex) => (React.createElement(Fragment, { key: baseProdIndex },
        React.createElement("div", null,
            React.createElement("button", { className: `product-button customised-image-elem ${bundleComponents[baseProdIndex].product.handle} ${currentFocusedBaseProduct == baseProdIndex ? 'product-button--active' : ''}`, onClick: () => selectPartToEdit(baseProdIndex, 0, 0) }, Object.values(bundleProd).map((bundleComp, compIndex) => bundleComp === null || bundleComp === void 0 ? void 0 : bundleComp.map((product, prodIndex) => (React.createElement("div", { className: `type--${product.part}`, key: `${baseProdIndex}-${compIndex}-${prodIndex}` },
                React.createElement("img", { src: product.selectedVariant.customiser_image }))))))),
        productSurcharge[baseProdIndex] > 0 ? React.createElement("div", { className: "price-tag price-tag--active" },
            "+",
            formatCurrency(productSurcharge[baseProdIndex] * 100)) : null)))));
};
export default GiftSetButtons;
